/* eslint-disable react-refresh/only-export-components */
import * as Constants from './constants';
import { CalculatorBag } from './types';
import { CalculatorOutput } from './components/CalculatorOutput/CalculatorOutput';
import { CalculatorDescription } from './components/CalculatorDescription';
import { Calculator } from './components/Calculator';

export const calculatorBag: CalculatorBag = {
  key: Constants.KEY,
  Input: Calculator,
  Output: CalculatorOutput,
  Description: CalculatorDescription,
};

export * from './types';
export type { CalculatorOutputProps } from './components/CalculatorOutput/types';
export * from './constants';
